module.exports = __webpack_public_path__ + "images/dde43b11.img_cancel.png";


//////////////////
// WEBPACK FOOTER
// ./core-dms/projects/candao-dms-std/orderLocation/images/img_cancel.png
// module id = 546
// module chunks = 99